import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { VisitType } from '@lmc/ts-common'
import { VISIT_TYPES_QUERY_KEY, VISIT_TYPES_URL } from './queryConstants'

export type VisitFormType = {
  types: VisitType[]
  flexiVisits: boolean
}

type UseVisitTypesListReturn = {
  visitTypes: VisitType[]
  flexiVisits: boolean
  isVisitTypesLoading: boolean
  refetch: () => void
}

export const useVisitTypesList = (): UseVisitTypesListReturn => {
  const {
    data: visitTypes,
    isLoading,
    refetch,
  } = useQuery(
    [VISIT_TYPES_QUERY_KEY] as string[],
    () =>
      getJSON({
        url: VISIT_TYPES_URL,
        isRota: true,
      }),
    { enabled: true }
  )

  return {
    visitTypes: visitTypes?.data.visitTypes,
    flexiVisits: visitTypes?.data.flexiVisits,
    isVisitTypesLoading: isLoading,
    refetch,
  }
}
